import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UliTypeComponent } from './uli-type.component';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../common/pipes/pipes.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [UliTypeComponent],
  imports: [CommonModule, TranslateModule, PipesModule, MatTooltipModule, SvgIconModule],
  exports: [UliTypeComponent],
})
export class UliTypeModule {}
